// import { signInAnonymously as firebaseSignInAnonymously, signInWithCustomToken as firebaseSignInWithCustomToken, getIdToken } from 'firebase/auth';
import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/storage";
import { authApp, firestoreApp } from './firebase';

/**
 * Asynchronously signs in a user anonymously using Firebase Authentication.
 *
 * @returns {Promise<firebase.auth.UserCredential>} A promise that resolves with the user credential object upon successful sign-in.
 * @throws Will throw an error if the sign-in process fails.
 */
export const signInAnonymously = async () => {
  try {
    console.log('Signing in anonymously...');
    return await firebase.auth(authApp).signInAnonymously();
  } catch (error) {
    console.error('Error signing in:', error);
    throw error;
  }
};
